module.exports = __webpack_public_path__ + "img/f2-3.d1c7e8f9.jpg";